<div class="tw-bg-white tw-rounded-lg tw-shadow-md tw-p-5 tw-shadow-tb tw-h-full">
        <mh-core-lib-loader-wrapper
        [type]="'spinner'"
        [loading]="loading"
        className="tw-w-full tw-flex tw-items-center tw-justify-center tw-text-4xl tw-h-full"
        >
      <div class="tw-flex tw-flex-col">
        <div class="tw-mb-3">
          <div class="tw-inline-block">
            <h2 [mhTooltip]="'followup.summary.nps.tooltip' | translate" position="above" class="tw-text-base tw-font-medium tw-font-['Rubik']">NPS</h2>
            <p class="tw-text-sm tw-text-gray-700">{{ status | lowercase | slice:0:1 | uppercase }}{{ status | lowercase | slice:1 }}</p>
          </div>
        </div>
        
        <section class="tw-flex tw-justify-between">
          <section class="tw-flex">
            <div>
              <div class="tw-flex tw-items-center tw-mb-2">
                <div class="tw-w-3 tw-h-3 tw-rounded-full tw-bg-green-500 tw-mr-2"></div>
                <span class="tw-text-sm">{{ 'followup.summary.nps.promoters' | translate }}:</span>
                <span class="tw-text-sm tw-font-medium tw-ml-1">{{ promoters }}%</span>
              </div>
          
              <div class="tw-flex tw-items-center tw-mb-2">
                <div class="tw-w-3 tw-h-3 tw-rounded-full tw-bg-orange-400 tw-mr-2"></div>
                <span class="tw-text-sm">{{ 'followup.summary.nps.passives' | translate }}:</span>
                <span class="tw-text-sm tw-font-medium tw-ml-1">{{ passives }}%</span>
              </div>
          
              <div class="tw-flex tw-items-center">
                <div class="tw-w-3 tw-h-3 tw-rounded-full tw-bg-red-500 tw-mr-2"></div>
                <span class="tw-text-sm">{{ 'followup.summary.nps.detractors' | translate }}:</span>
                <span class="tw-text-sm tw-font-medium tw-ml-1">{{ detractors }}%</span>
              </div>
            </div>
          </section>
      
          <section>
            <mh-core-lib-gauge
              [value]="value"
              [mhTooltip]="'followup.summary.nps.tooltip_graph' | translate"
              position="above"
              [max]="100"
              [min]="-100"
              [size]="155"
              [thickness]="25"
              [backgroundColor]="'#e0e0e0'">
            </mh-core-lib-gauge>
          </section>
        </section>
        
        <div class="tw-flex tw-justify-end tw-gap-4">
          <button class="tw-text-main tw-font-['Rubik'] tw-text-sm tw-font-semibold tw-text-end" (click)="onDownloadEbook()">{{ 'commons.download_ebook' | translate | uppercase }}</button>
          <button *ngIf="!hideViewMoreButton" class="tw-text-main tw-font-['Rubik'] tw-text-sm tw-font-semibold tw-text-end" (click)="onViewMore()">{{ 'commons.see_trend' | translate | uppercase }}</button>
        </div>
      </div>
      
</mh-core-lib-loader-wrapper>
</div>